<template>
  <BaseModal v-bind="modalAttrs"
             v-on="$listeners"
             :name="name">
    <slot />
  </BaseModal>
</template>

<script>
  import BaseModal from '@base/base-modal'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ModalPrimary',
    inheritAttrs: false,
    components: {
      BaseModal,
    },
    props: {
      name: { type: String, required: true },
    },
    data: function () {
      return {
        modalAttrs: {
          adaptive: true,
          draggable: false,
          height: 'auto',
          resizable: false,
          scrollable: true,
          styles: {
            borderRadius: '8px',
            boxShadow: 'none',
            padding: Layout.space.lg,
          },
          width: '90%',
        },
      };
    },
    created: function () {
      this.modalAttrs = {
        ...this.modalAttrs,
        ...this.$attrs,
      };
      this.modalAttrs.styles = {
        ...this.modalAttrs.styles,
        backgroundColor: this.color.light1(),
        border: `solid 1px ${this.color.dark5()}`,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
